import { useQuery } from 'react-query';

import { IRequestPayload } from 'core/types';
import { supportReportService } from 'reports/services';
import {
  IBomHeaderJob,
  IBomHeaderRequestPayload,
  IBomsByPart,
  ILinesByPart,
  IReportSummary,
  IReportSummaryRequestPayload,
} from 'reports/types';

export const useGetBomHeader = (requestPayload: IBomHeaderRequestPayload) => {
  const { data, isLoading, isFetching, isError } = useQuery(
    ['supportReportBomHeader', requestPayload],
    ({ signal }) => supportReportService.getBomHeaderReport(requestPayload, signal),
    {
      keepPreviousData: true,
    }
  );

  return {
    isError,
    isFetching,
    isLoading,
    records: (data?.records ?? []) as IBomHeaderJob[],
  };
};

export const useGetLinesByPart = (requestPayload: IBomHeaderRequestPayload) => {
  const { data, isLoading, isFetching, isError } = useQuery(
    ['supportReportLinesByPart', requestPayload],
    ({ signal }) => supportReportService.getLinesByPartReport(requestPayload, signal),
    {
      keepPreviousData: true,
    }
  );

  return {
    isError,
    isFetching,
    isLoading,
    records: (data?.records ?? []) as ILinesByPart[],
  };
};

export const useGetBomsByPart = (requestPayload: IBomHeaderRequestPayload) => {
  const { data, isLoading, isFetching, isError } = useQuery(
    ['supportReportBomsByPart', requestPayload],
    ({ signal }) => supportReportService.getBomsByPartReport(requestPayload, signal),
    {
      keepPreviousData: true,
    }
  );

  return {
    isError,
    isFetching,
    isLoading,
    records: (data?.records ?? []) as IBomsByPart[],
  };
};

export const useSummary = (requestPayload: IReportSummaryRequestPayload) => {
  const { data, isLoading, isFetching, isError } = useQuery(
    ['supportReportSummary', requestPayload],
    ({ signal }) => supportReportService.getSupportReportSummary(requestPayload, signal),
    {
      keepPreviousData: true,
    }
  );

  return {
    isError,
    isFetching,
    isLoading,
    record: data?.record as IReportSummary,
  };
};

export const useGetExternalLocationRegionsAutocomplete = (requestPayload: IRequestPayload) => {
  const { data, isLoading, isFetching, isError } = useQuery(
    ['supportReportExternalLocationRegionsAutocomplete', requestPayload],
    ({ signal }) =>
      supportReportService.getExternalLocationRegionsAutocomplete(requestPayload, signal),
    {
      keepPreviousData: true,
    }
  );

  return {
    externalLocationRegions: data?.records ?? [],
    isError,
    isFetching,
    isLoading,
    totalCount: data?.count ?? 0,
  };
};
